import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
import ModuleLoaderLazy from '../redux/ModuleLoaderLazy';
import AbsoluteHeightLayout from '@wix/da-ds/pkg/AbsoluteHeightLayout';

import variables from '@wix/da-ds/src/styles/variables.scss';
const siteHeaderHeight = parseInt(variables['site-header-height'], 10);

const FeedbackPage = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "notifications_shared" */
        './index'
      )
  )
);

export interface Props {
  loadingIndicator?: boolean | React.ReactNode | React.ReactElement | React.ReactPortal | null;
}

export const FeedbackPageLoadable: React.FC<Props> = ({ loadingIndicator }) => {
  return (
    <ErrorBoundary debugComponent="FeedbackPageLoadable">
      <AbsoluteHeightLayout heightReduction={siteHeaderHeight} disableIfDvSupported>
        <Suspense fallback={loadingIndicator || null}>
          <ModuleLoaderLazy />
          <FeedbackPage />
        </Suspense>
      </AbsoluteHeightLayout>
    </ErrorBoundary>
  );
};
FeedbackPageLoadable.displayName = 'FeedbackPageLoadable';

export default FeedbackPageLoadable;
